import { gsap } from "gsap"

/**
 * Initializes the full-screen clip-path navigation menu overlay with a per-line clip-path wipe effect.
 */
export function initNavigationMenu() {
  const openBtn = document.getElementById("open-menu-btn")
  const closeBtn = document.getElementById("close-menu-btn")
  const menuOverlay = document.getElementById("menu-overlay")

  if (!openBtn || !closeBtn || !menuOverlay) return

  const zoneAmber = document.querySelector(".js-anim-amber")
  const zoneBrown = document.querySelector(".js-anim-brown")
  const zoneGreen = document.querySelector(".js-anim-green")
  const zoneGreenFaded = document.querySelector(".js-anim-green-faded")

  const panels = [zoneAmber, zoneBrown, zoneGreen, zoneGreenFaded]
  const menuLines = document.querySelectorAll(".js-reveal-line")

  // 1. Initial State Setups (Panels & Buttons)
  gsap.set(panels, {
    force3D: true,
    z: 0.1,
    willChange: "transform, clip-path"
  })

  gsap.set(zoneAmber, { clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)" })
  gsap.set(zoneBrown, { clipPath: "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)" })
  gsap.set(zoneGreen, { clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)" })
  gsap.set(zoneGreenFaded, { clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)" })

  gsap.set(closeBtn, {
    opacity: 0,
    scale: 0.8,
    force3D: true,
    willChange: "opacity, transform"
  })

  // NEW: Configure initial hidden state for each line (Shifted down + Mask closed at the bottom)
  gsap.set(menuLines, {
    y: 30, // Slight physical pixel offset feels more controlled than large percentages
    clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
    force3D: true,
    willChange: "transform, clip-path"
  })

  const fullReveal = "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"
  const duration = 0.95
  const ease = "power3.inOut"

  // 2. Master Menu Timeline
  const menuTimeline = gsap.timeline({
    paused: true,
    onReverseComplete: () => {
      menuOverlay.classList.add("hidden")
    }
  })

  menuTimeline
    // A. Open background color panels
    .to(panels, {
      clipPath: fullReveal,
      duration,
      ease,
      stagger: 0
    })
    // B. Per-line simultaneous transform & clip-path reveal wipe
    .to(
      menuLines,
      {
        y: 0,
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", // Open line mask
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.08 // Elegant staggered line timing gap
      },
      "-=0.45" // Triggers early mid-color sweep for a highly integrated feel
    )
    // C. Reveal close trigger button
    .to(
      closeBtn,
      {
        opacity: 1,
        scale: 1,
        duration: 0.25,
        ease: "back.out(1.4)"
      },
      "-=0.3"
    )

  // 3. Control Event Binding Actions
  openBtn.addEventListener("click", () => {
    menuOverlay.classList.remove("hidden")
    menuTimeline.play()
  })

  closeBtn.addEventListener("click", () => {
    menuTimeline.reverse()
  })
}
